/**
 * Convert a business object (as it lands in the BusinessContext / on
 * the active acting-as identity) into the structured-address shape
 * that AddressAutocomplete.value expects.
 *
 * Used by every listing-style composer plugin (jobType, classType,
 * spacesType) to seed `state.address` so newly-created listings default
 * to the business's location rather than a blank field. The user can
 * still override per-listing (mobile stylist serving a different city,
 * off-site class, etc.) — this only sets a starting value.
 *
 * Returns null when the business hasn't filled in its location yet,
 * which leaves the picker empty (the SidebarAlerts CTA prompts them
 * to set it from Settings → Business Location).
 */
export const addressFromBusiness = (business) => {
  if (!business) return null
  const lat = business.addressLat
  const lng = business.addressLng
  if (lat == null || lng == null) return null
  return {
    placeId: business.addressPlaceId || '',
    line1: business.addressLine1 || '',
    city: business.addressCity || '',
    state: business.addressState || '',
    postalCode: business.addressPostalCode || null,
    country: business.addressCountry || '',
    lat: Number(lat),
    lng: Number(lng),
    formatted:
      [business.addressLine1, business.addressCity, business.addressState]
        .filter(Boolean)
        .join(', ') ||
      business.location ||
      '',
  }
}
